export class VaultVersions {
    static readonly VERSION_1: number = 1;
}